import SwipingArea from '../components/SwipingArea';

export const Home = () => {
	return (
		<div className="container">
			<SwipingArea />
		</div>
	);
};
